import { Box, Link, Typography } from 'ui';

import { AuthLayout } from '../../components/AuthLayout/AuthLayout';

export const SignUpSuccess = () => (
  <AuthLayout
    title="Trade recyclables the smart way"
    subtitle="You are only a few steps away from creating your account and getting started with Safi."
  >
    <Box mb={6}>
      <Typography variant="h5" fontWeight="bold">
        We&apos;ll be in touch
      </Typography>
    </Box>
    <Typography>
      We&apos;re thrilled to have you on board! We want to make sure that you get the most value out of Safi&apos;s
      offering.
    </Typography>
    <Typography>
      Our representative will be in touch soon to dive deeper into your needs and discuss the next steps to start
      trading with Safi.
    </Typography>
    <Typography>
      If you have any questions, contact us at&nbsp;
      <Link href="mailto:support@safi.co">support@safi.co</Link>
    </Typography>
  </AuthLayout>
);
